import FiltersSidebar from "./FiltersSidebar";

export default FiltersSidebar;
